import { IRedeemRequestHeaders, IEventRequestHeaders } from 'types/request';

interface ICreateRequestData {
    ticket: string | undefined;
    applicationId: string;
}

interface ICreateRedeemRequestData extends ICreateRequestData {
    sessionId: string;
}

interface ICreateEventRequestData {
    ticket: string;
    applicationId: string;
}

export const createRedeemRequestHeaders = ({ ticket, applicationId, sessionId }: ICreateRedeemRequestData): IRedeemRequestHeaders => ({
    'Content-Type': 'application/json',
    'Ubi-AppId': applicationId,
    'Ubi-SessionId': sessionId,
    Authorization: `Ubi_v1 t=${ticket}`
});

export const createEventReuqestHeaders = ({ ticket, applicationId }: ICreateEventRequestData): IEventRequestHeaders => ({
    'Content-Type': 'application/json',
    'Ubi-AppId': applicationId,
    'Ubi-Ticket': ticket
});
